/* COD button management for the v2 theme + Releasit embed (no app block).
   1) Releasit sometimes injects its styled button twice — keep exactly one.
   2) When Releasit's button is present in a form, hide the theme's own submit
      button in that form (and un-hide it again if the app's button disappears),
      so the page always shows exactly one order button. */
(function(){
  function pass(){
    var btns=document.querySelectorAll('#rsi_buy_now_button,[id^="rsi_buy_now"]');
    /* dedupe extras */
    if(btns.length>1){
      var keep=null,i;
      for(i=0;i<btns.length;i++){ if(btns[i].closest('form')){ keep=btns[i]; break; } }
      if(!keep) keep=btns[0];
      for(i=btns.length-1;i>=0;i--){
        if(btns[i]===keep) continue;
        var extra=btns[i], parent=extra.parentElement;
        extra.remove();
        if(parent&&!parent.children.length&&!parent.closest('form')&&parent!==document.body) parent.remove();
      }
      btns=document.querySelectorAll('#rsi_buy_now_button,[id^="rsi_buy_now"]');
    }
    /* hide the theme submit wherever an app button lives in the same form */
    document.querySelectorAll('form.cod-appform').forEach(function(f){
      var appBtn=f.querySelector('#rsi_buy_now_button,[id^="rsi_buy_now"]');
      var own=f.querySelector('button[name="add"]');
      if(own) own.style.display=appBtn?'none':'';
    });
  }
  function schedule(){
    pass();
    [500,1200,2500,4000,7000,12000].forEach(function(ms){ setTimeout(pass,ms); });
    if(window.MutationObserver){
      var pend=false;
      var mo=new MutationObserver(function(){ if(pend) return; pend=true;
        requestAnimationFrame(function(){ pend=false; pass(); }); });
      mo.observe(document.body,{childList:true,subtree:true});
      setTimeout(function(){ mo.disconnect(); pass(); },30000);
    }
  }
  if(document.readyState==='complete') schedule(); else window.addEventListener('load',schedule);
})();
